<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <div [class.input-group]="prefix || suffix">
    <div class="input-group-addon" *ngIf="prefix">{{ prefix }}</div>
    <input #input [attr.readonly]="schema.readOnly?true:null" [name]="name"
      class="text-widget integer-widget form-control" [formControl]="control"
      [attr.type]="'number'" [attr.step]="step" [attr.min]="schema.minimum" [attr.max]="schema.maximum"
      [attr.placeholder]="schema.placeholder"
      [attr.maxLength]="schema.maxLength || null"
      [attr.minLength]="schema.minLength || null" />
    <div class="input-group-addon" *ngIf="suffix">{{ suffix }}</div>
  </div>
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/integer.widget.html